<template>
  <div class="pn dinline-block vtop ofhidden br5 pl25 mb15">
    高起专函授：联系电话&nbsp;<span class="fbold">{{item.phone}}</span>&nbsp;&nbsp;{{item.name}}
  </div>
</template>

<script>
export default {
  name: "teacher",
  props: [
    'item',
    'index',
  ]
}
</script>

<style scoped>
  .mcollege-wrap .college .pn{margin-bottom: 25px;margin-right: 22px;width: 365px;height: 60px;line-height: 60px;background: #e0e9f5;}
</style>



// WEBPACK FOOTER //
// src/components/main/about/teacher.vue